import type { SpotCloseSegmentContent } from './type';
import spotCloseSegmentData from '../../../data/spotCloseSegment.json';

export class spotCloseSegmentService {
  async getSpotCloseSegmentData(): Promise<{ data: SpotCloseSegmentContent }> {
    return { data: spotCloseSegmentData.data };
  }

  async getSegmentsByState(stateId: number): Promise<{ data: SpotCloseSegmentContent }> {
    const allData = spotCloseSegmentData.data;
    const filteredSegments = allData.segments.filter(segment => segment.status.id === stateId);


    const totalOPDia = filteredSegments.length;
    const totalPurchaseAmount = filteredSegments
      .filter(seg => seg.cv.id === 2)
      .reduce((sum, seg) => sum + seg.amountCLP, 0);
    const totalSaleAmount = filteredSegments
      .filter(seg => seg.cv.id === 1)
      .reduce((sum, seg) => sum + seg.amountCLP, 0);
    const profit = filteredSegments
      .reduce((sum, seg) => sum + (seg.profit || 0), 0);

    return {
      data: {
        totalOPDia,
        totalPurchaseAmount,
        totalSaleAmount,
        profit,
        segments: filteredSegments
      }
    };
  }
}